// const development = 'https://web.Poynex.net';
const development = 'https://web.poynexmax.net';

// 后端api前缀
const hosts = {
    development: development + '/api',
    production: '/api'
};

// 币本位请求
const dapi_Url = {
    development: development + '/dapi/v1',
    production: '/dapi/v1'
};
// otc请求
const otc_url = {
    development: development + '/sapi',
    production: '/sapi'
};

const st_Url = {
    development: development + '/st/v1',
    production: '/st/v1'
};

// 量化请求
const earn_url = {
    development: development + '/earn/v1',
    production: '/earn/v1'
};

// 现货 ws url
const spotws = {
    development: 'wss://web.poynexmax.net/k/api/spot/',
    production: 'wss://web.poynexmax.net/k/api/spot/'
    // production: 'wss://app.Poynex.net:3356/'
};

// u本位 ws url
const futws = {
    development: 'wss://web.poynexmax.net/k/api/fu/u/',
    production: 'wss://web.poynexmax.net/k/api/fu/u/'
    // production: 'wss://app.Poynex.net:3335/'
};
// 币本位 ws url
const deliveryws = {
    development: 'wss://web.poynexmax.net/k/api/fut/coin/',
    production: 'wss://web.poynexmax.net/k/api/fut/coin/'
    // production: 'wss://app.Poynex.net:3345/'
};
// otc ws url
const otcws = {
    development: 'wss://app.nuxkmby.com:3338/',
    production: 'wss://app.Poynex.net:3338/'
    // production: 'wss://app.Poynex.net:3338/'
};

// 定义变量(是否是测试环境还是测试其他环境)
const env = process.env.NODE_ENV;
// console.log(process.env)
export const host = hosts[env];

export const otc_baseUrl = otc_url[env];

export const dapi_baseUrl = dapi_Url[env];

export const st_baseUrl = st_Url[env];

export const earn_baseUrl = earn_url[env];

export const spotws_url = spotws[env]; // 现货 ws url
export const futws_url = futws[env]; // u本位 ws url
export const deliveryws_url = deliveryws[env]; // 币本位 ws url
export const otcws_rul = otcws[env]; // otc ws url
